import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ContentItemPlusInteractives } from "scmp-app/components/content/content-item-render/variants/plus-interactives";
import { Cover } from "scmp-app/components/content/content-item-render/variants/plus-interactives/styles";

export const StyledContentItemPlusInteractives = styled(ContentItemPlusInteractives)`
  ${Cover} {
    inline-size: 100%;
    max-inline-size: 200px;

    img {
      inline-size: 100%;
      max-inline-size: 200px;
    }
  }

  ${theme.breakpoints.up("desktop")} {
    ${Cover} {
      max-inline-size: unset;
      img {
        max-inline-size: unset;
      }
    }
  }
`;

export const ContentItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Container = styled.div``;
